<template>
<div class="copyright z50 active">
  <div class="inner">
    <span class="copyright_text">&copy; {{year}} Hugendubel</span>&nbsp;|&nbsp;
    <router-link to="/impressum" class="impressum_link">Impressum</router-link>&nbsp;|&nbsp;
    <router-link to="/datenschutz" class="datenschutz_link">Datenschutz</router-link>&nbsp;|&nbsp;
    <router-link to="/Elterninfo_zusatz" class="datenschutz_link">Weitere Elterninfo</router-link>
  </div>
</div>
</template>

<script>
window.$ = window.jQuery = require('jquery')

export default {
  name: 'copyright',
  data () {
    var d = new Date()
    return {
      who: 'copyright',
      year: d.getFullYear()
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

.copyright {
  position: absolute;
  left: 250px;
  bottom: 1vh;
  font-family: "Open Sans";
  color: #5f5f5f;
  font-size: 10px;
}

.copyright a {
  font-family: "Open Sans";
  font-size: 10px;
  color: #5f5f5f;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Copyright.vue